var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-section"},[_c('emd-tabbar',{attrs:{"items":_vm.tabbarItems,"activeItem":_vm.$router.currentRoute.name,"bordered":""},on:{"changed":_vm.goToRoute}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }